import { Center, Loader } from '@mantine/core';
import React from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
// import Album  from './pages/home/album';

const Home = React.lazy(() => import('./pages/home/home'))
const LogOut = React.lazy(() => import('./pages/logOut'))
const Album = React.lazy(() => import('./pages/home/album'))

// import Home from './pages/home/home';
// import LogOut from './pages/logOut';

function App() {
  
  return (
    <HashRouter>
      <React.Suspense fallback={
      <div style=
        {
          {
            height: "100vh",
            width: "100vw",
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center"
          }
        }>
          <Loader variant='oval' color={"lime.9"} size={"xl"} />
      </div>}>
        <Routes>
          <Route path='/' element={<Home />}/>
          <Route path='logOut' element={<LogOut />}/>
          <Route path="album/:id" element={<Album/>} />
        </Routes>
      </React.Suspense>
    </HashRouter>
  );
}

export default App;
